import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export default {
  confirmation({title = '', text, confirmButtonClass, cancelButtonClass, allowEscapeKey = true, cancelButtonText = 'No', confirmButtonText = 'Yes'}) {
    return swal({
      title: title,
      text: text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#6f1b57',
      cancelButtonColor: '#c5c5c5',
      cancelButtonText: cancelButtonText,
      confirmButtonText: confirmButtonText,
      confirmButtonClass: confirmButtonClass,
      cancelButtonClass: cancelButtonClass,
      allowEscapeKey
    });
  },

  success({title = 'Success', text, confirmButtonClass, html}) {
    return swal({
      title,
      text,
      html,
      type: 'success',
      confirmButtonColor: '#6f1b57',
      confirmButtonClass
    });
  },

  error({title = 'Error', text}) {
    return swal({
      title,
      text,
      type: 'error',
      confirmButtonColor: '#6f1b57',
    });
  },

  info({title = 'Info', text}) {
    return swal({
      title,
      text,
      confirmButtonColor: '#6f1b57',
    });
  },

  show({title, text}) {
    return swal({
      title,
      text,
      confirmButtonColor: '#6f1b57',
    });
  },
};
